import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@components/Typography';
import { Table } from '@components/Table';
import { useTranslation } from '@hooks';
import { FullScreenModal, cellStyles } from './styles';

const cell = value => (
    <Typography variant="body2" align="left" style={cellStyles}>
        {value || '--'}
    </Typography>
);

const GetContactsColumnNames = () => {
    const { t } = useTranslation();
    return [
        { key: 0, component: <Typography variant="subtitle2">{t('SendInvites.id')}</Typography> },
        {
            key: 1,
            component: (
                <Typography variant="subtitle2" align="left">
                    {t('common.name')}
                </Typography>
            ),
        },
        {
            key: 2,
            component: (
                <Typography align="left" variant="subtitle2">
                    {t('common.phoneNumber')}
                </Typography>
            ),
        },
        {
            key: 3,
            component: (
                <Typography align="left" variant="subtitle2">
                    {t('common.email')}
                </Typography>
            ),
        },
        {
            key: 4,
            component: (
                <Typography align="left" variant="subtitle2">
                    {t('ContactsPage.facebookProfile')}
                </Typography>
            ),
        },
        {
            key: 5,
            component: (
                <Typography align="left" variant="subtitle2">
                    {t('ContactsPage.instagramProfile')}
                </Typography>
            ),
        },
        {
            key: 6,
            component: (
                <Typography align="left" variant="subtitle2">
                    {t('common.externalId')}
                </Typography>
            ),
        },
    ];
};

const getContactsRows = contacts =>
    contacts.map(({ firstName, lastName, phoneNumber, email, facebook, instagram, externalId }, index) => [
        {
            component: (
                <Typography variant="subtitle2" align="left" sx={{ maxWidth: '56px' }}>
                    {index + 1}
                </Typography>
            ),
        },
        { component: cell(`${firstName || '-'} ${lastName || '-'}`) },
        { component: cell(phoneNumber) },
        { component: cell(email) },
        { component: cell(facebook) },
        { component: cell(instagram) },
        { component: cell(externalId) },
    ]);

const AddedContactsModal = ({ isOpen, onClose, contacts }) => {
    const { t } = useTranslation();

    return (
        <FullScreenModal
            fullScreen
            isOpen={isOpen}
            handleClose={onClose}
            title={t('SendInvites.addedContacts')}
            onPrimaryAction={onClose}
            primaryActionText={t('buttons.done')}
        >
            <TableContainer>
                <Table columnNames={GetContactsColumnNames()} rows={getContactsRows(contacts)} />
            </TableContainer>
        </FullScreenModal>
    );
};

export default AddedContactsModal;
